/* 🤖 this file was generated by svg-to-ts */
export const kzIconsCrosshair: {
  name: 'crosshair';
  data: string;
} = {
  name: 'crosshair',
  data: `<svg viewBox="0 0 16 16" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1.5"><ellipse cx="8" cy="8" rx="3.95" ry="3.93" fill="none" stroke="currentColor" stroke-width="1.5px"/><path d="M14.7 7.2H12c-.4 0-.8.3-.8.8s.3.8.8.8h2.7c.4 0 .8-.3.8-.8s-.4-.8-.8-.8ZM4.8 8c0-.4-.3-.8-.8-.8H1.3c-.4 0-.7.4-.7.8s.3.8.8.8H4c.4 0 .8-.4.8-.8ZM8 4.8c.4 0 .8-.3.8-.8V1.3c0-.4-.3-.8-.8-.8s-.8.4-.8.8V4c0 .4.4.8.8.8ZM8 11.2c-.4 0-.8.3-.8.8v2.7c0 .4.3.8.8.8s.8-.3.8-.8V12c0-.4-.4-.8-.8-.8Z" fill-rule="nonzero"/><circle cx="8" cy="8" r="2"/></svg>`
};
